import React from "react";
import "../../assets/styles/Loader.css"

const Loader = () => {
  return (
    <div className="loader-container">
    <div className="loader">
    {/* <div className="loader-border"></div> */}
      {/* <img src={Logo} alt="Website Logo" className="loader-logo" /> */}
    </div>
  </div>
  );
};
export default Loader;

